import { euro } from '@immoaktas/shared';

type TFn = (key: string, opts?: Record<string, unknown>) => string;

/** Labels for web-only value sets (property types, ledger entries, report states …); unknown values show as is. */
export type WebEnumGroup =
  | 'propertyType'
  | 'heatingType'
  | 'ledgerEntry'
  | 'paymentStatus'
  | 'reportCategory'
  | 'reportStatus'
  | 'readingStatus'
  | 'eventType'
  | 'yearFileStatus'
  | 'coverage'
  | 'plan'
  | 'deliveryChannel';
export const webEnum = (t: TFn, group: WebEnumGroup, value: string) => t(`enums.${group}.${value}`, { defaultValue: value });

/** Tenant account balance: positive = tenant owes ("offen 12,00 €"). */
export const ledgerBalanceText = (t: TFn, cents: number) =>
  cents > 0 ? t('ledger.balanceOpen', { amount: euro(cents) }) : cents < 0 ? t('ledger.balanceCredit', { amount: euro(-cents) }) : t('common:balance.even');
